module.exports = __webpack_public_path__ + "static/highlight-client-06154b824562f75951b32f765d7bb6c3.jpg";